import React, { type VFC } from 'react';

import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart';
import { APP_NAVIGATION_METRIC } from '@confluence/browser-metrics/entry-points/app-navigation.metric';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary';

import { TopNavigation } from '../src/TopNavigation';
import type { useCustomTheme } from '../src/theme/useCustomTheme';

export const TopNavigationBase: VFC<{
	defaultCollapsed: boolean;
	customTheme: ReturnType<typeof useCustomTheme>;
}> = ({ defaultCollapsed, customTheme }) => {
	return (
		<ErrorBoundary
			attribution={Attribution.DISCO}
			attributes={{
				errorBoundaryId: 'TopNavigation',
			}}
		>
			<PageSegmentLoadStart metric={APP_NAVIGATION_METRIC} />
			<TopNavigation defaultCollapsed={defaultCollapsed} customTheme={customTheme} />
		</ErrorBoundary>
	);
};
